import {Container, Text} from "pixi.js";
import {Vector} from "../i.js";
import {UIUtils} from "../i.js";
import {Button} from "../i.js"; // ./button.js
import {Tab} from "../i.js"; // ./tab.js

export const ACHIEVEMENTS = {
	UPGRADE: "UPGRADE",
	PRANK_BRO: "PRANK_BRO",
	ROCKY_START: "ROCKY_START",
	THRUSTERS: "THRUSTERS",
	COSSETTE: "COSSETTE",
	BEACONY: "BEACONY",
	COMPASS: "COMPASS",
	ESCAPE: "ESCAPE"
};

const ACHIEVEMENTS_INFO = new Map([
	[ACHIEVEMENTS.UPGRADE, {
		name: "???",
		description: "Get an upgrade"
	}],
	[ACHIEVEMENTS.PRANK_BRO, {
		name: "Just a prank, bro!",
		description: "Defeat the Gyroscope Prankster"
	}],
	[ACHIEVEMENTS.ROCKY_START, {
		name: "A rocky start",
		description: "Defeat a Meteorus"
	}],
	[ACHIEVEMENTS.THRUSTERS, {
		name: "???",
		description: "Forge the maneuvering thrusters"
	}],
	[ACHIEVEMENTS.COSSETTE, {
		name: "???",
		description: "Get a lift from Cossette"
	}],
	[ACHIEVEMENTS.BEACONY, {
		name: "???",
		description: "Alert a beacony"
	}],
	[ACHIEVEMENTS.COMPASS, {
		name: "???",
		description: "Destroy a compass"
	}],
	[ACHIEVEMENTS.ESCAPE, {
		name: "???",
		description: "Escape the game area"
	}]
]);



class MainSubTab {
	constructor(tab) {
		this.display = new Container();
		this._achievementsButton = new Button(tab.unicenter);
		this.display.addChild(this._achievementsButton);
	}

	// Return name of the tab to switch to, or null
	wantToSwitch() {
		return this._achievementsButton.wasClicked() ? "ACHIEVEMENTS" : null;
	}

	update(size, visible) {
		this._achievementsButton.clearStuff();

		if (!visible) {
			this.display.visible = false;
			return;
		}
		this.display.visible = true;

		let achievementsButtonSize = new Vector(size.x / 3, size.y / 4).round();
		let achievementsButtonPosition = Vector.diff(size, achievementsButtonSize);
		this._achievementsButton.update(
			0x1a2c17,
			0x6aff4d,
			achievementsButtonPosition,
			achievementsButtonSize,
			"Achievements"
		);
	}
}



class AchievementsSubTab {
	constructor(tab) {
		this.tab = tab;
		this.display = new Container();

		this._completion = new Map(
			Object.values(ACHIEVEMENTS).map((achievement) => [achievement, false])
		);

		this._backButton = new Button(tab.unicenter);
		this._text = new Text("", UIUtils.getFont(0x6aff4d));
		this.display.addChild(this._backButton, this._text);
	}

	// Return name of the tab to switch to, or null
	wantToSwitch() {
		return this._backButton.wasClicked() ? "MAIN" : null;
	}

	update(size, visible) {
		this._backButton.clearStuff();

		if (!visible) {
			this.display.visible = false;
			return;
		}
		this.display.visible = true;

		let backButtonSize = new Vector(size.x / 3, size.y / 4).round();
		let backButtonPosition = new Vector();
		this._backButton.update(
			0x1a2c17,
			0x6aff4d,
			backButtonPosition,
			backButtonSize,
			"Back"
		);

		let textPosition = new Vector(
			0,
			backButtonPosition.y + backButtonSize.y
							+ this.tab.unicenter.requestMarginWidth(2)
		);
		this._text.position.copyFrom(textPosition);
		this._text.style.fontSize = this.tab.unicenter.requestFontSize("SMALL");
		this._text.text = Object.values(ACHIEVEMENTS)
			.map(achievement => {
				let isObtained = this._completion.get(achievement)
								? "\u2612" : "\u2610";
				let description = ACHIEVEMENTS_INFO.get(achievement).description;
				return `${isObtained} ${description}`;
			})
			.join("\n");
	}

	recordAchievement(achievement) {
		this._completion.set(achievement, true);
	}
}



export class Ship extends Tab {
	// Create a new ship monitor
	// Each unicenter should create exactly one ship monitor. unicenter is a
	// reference to the unicenter.
	constructor(unicenter) {
		super(
			unicenter,
			null,
			Tab.LOCATIONS.RIGHT,
			"images/icons/ship.svg",
			0x1a2c17,
			0x6aff4d,
			"Ship"
		);

		this.achievements = new AchievementsSubTab(this);
		this._subTabs = new Map([
			["MAIN", new MainSubTab(this)],
			["ACHIEVEMENTS", this.achievements]
		]);
		this._subTabs.forEach(subTab => this.display.addChild(subTab.display));
		this._selectedSubTab = "MAIN";
	}

	// Update the ship
	// Call this every tick. visible is a boolean that is true if the display is
	// visible this tick. size is a vector in pixels representing the desired
	// size of the display.
	update(visible, size) {
		super.update(visible, size);
	}

	// Refresh the display, redrawing everything from scratch
	// This method only needs to be called when something actually changed, but
	// it's okay to call it every tick.
	_refreshDisplay() {
		let size = this.display.size;

		let desiredSubTab = this._subTabs.get(this._selectedSubTab).wantToSwitch();
		if (desiredSubTab !== null) this._selectedSubTab = desiredSubTab;

		this._subTabs.forEach(
			(subTab, name) => subTab.update(size, name === this._selectedSubTab)
		);
	}
}
